import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
  Card,
  CardTitle,
  CardBody,
  Collapse,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import LicMgtAddLicenseForm from "../LicMgt/LicMgtAddLicenseForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LicMgtLicensesTable from "../Tables/LicMgtLicensesTable";
import LicMgtCustomerCard from "../LicMgt/LicMgtCustomerCard";

export default function LicMgtCustomerModal({
  toggle,
  isOpen,
  customer,
  licenseCourses,
  handleUpdateData,
  toggleUpdate,
}) {
  const [addLicenseOpen, setAddLicenseOpen] = useState(false);

  if (customer == null) {
    return null;
  }

  return (
    <Modal
      size="xl"
      style={{ maxWidth: "88vw", width: "100%" }}
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader>{customer.customer.name}</ModalHeader>
      <ModalBody>
        <LicMgtCustomerCard
          customer={customer}
          handleUpdateData={handleUpdateData}
        />
        <Card>
          <CardBody>
            <CardTitle>
              <FormattedMessage id="Licenses" />{" "}
              <Button
                outline
                color="primary"
                className="float-end"
                onClick={() => setAddLicenseOpen(!addLicenseOpen)}
              >
                <FontAwesomeIcon
                  style={{ marginRight: ".5em" }}
                  className={
                    addLicenseOpen
                      ? "fa-caret--animated collapsed"
                      : "fa-caret--animated"
                  }
                  icon={"caret-up"}
                />

                <FormattedMessage id="AddCourse" />
              </Button>
            </CardTitle>
            <Collapse isOpen={addLicenseOpen} className="border my-3 p-2">
              <LicMgtAddLicenseForm
                courses={licenseCourses}
                customer={customer.customer}
                handleUpdateData={handleUpdateData}
                setAddLicenseOpen={setAddLicenseOpen}
              />
            </Collapse>
            <LicMgtLicensesTable
              customer={customer}
              toggleUpdate={toggleUpdate}
              handleUpdateData={handleUpdateData}
            />
          </CardBody>
        </Card>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          <FormattedMessage id="Cancel" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
